<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="user.email">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name"
                      placeholder="Name"
                      v-model="user.nickname">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame) === '4003'" class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Vorname"
                      placeholder="Vorname"
                      v-model="user.firstname">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame) === '4003'" class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nachame"
                      placeholder="Nachname"
                      v-model="user.lastname">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Source"
                      placeholder="Source"
                      v-model="user.source">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame) === '1702' || ('' + this.$store.state.betgame) === '1902'" class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Adresse"
                      placeholder="Adresse"
                      v-model="user.address">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Sonderpunkte"
                      placeholder=""
                      v-model="user_betgame_points">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame === '1') || ('' + this.$store.state.betgame === '11')" class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Strasse und Hausnummer"
                      placeholder="Strasse und Hausnummer"
                      v-model="user.address">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame === '1') || ('' + this.$store.state.betgame === '11')" class="row">
          <div class="col-md-2">
            <fg-input type="text"
                      label="PLZ"
                      placeholder="PLZ"
                      v-model="user.zip">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
                      label="Ort"
                      placeholder="Ort"
                      v-model="user.city">
            </fg-input>
          </div>
        </div>
        <div v-if="('' + this.$store.state.betgame === '1') || ('' + this.$store.state.betgame === '7')" class="row">
          <div class="col-md-12">
            <div class="input-checkbox" style="margin-top: 10px; margin-bottom: 30px;">
              <input style="vertical-align: top;" v-model="user.allow_email" type="checkbox" id="newsletterSubscription" name="newsletterSubscription" />
              <label style="margin-left: 3px;" for="newsletterSubscription">Werbeeinwilligung</label>
            </div>
          </div>
        </div>
        <!--
        <div v-if="this.id === 0 && isValidEmail(user.email)" class="row" style="margin-top: 15px;">
          <div class="col-md-12">
            <p-checkbox v-model="sendValidationEmailOnSave">Beim Speichern Registrierungs Email senden</p-checkbox>
          </div>
        </div>
        -->

        <div class="row">
          <div class="col-md-6">
            <fg-input type="password"
                      v-model="new_password"
                      label="Passwort"
                      placeholder="Passwort">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="password"
                      v-model="new_password_repeat"
                      label="Passwort wiederholen"
                      placeholder="Passwort">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <!--
            <fg-input type="text"
                      label="Status"
                      placeholder="Name"
                      v-model="user.status">
            </fg-input>
            -->
            <label>Status</label>
            <select name="status" id="status"
                    v-model="user.status"
                    class="form-control">
              <option value="active">Aktiv</option>
              <option v-if="user.id > 0" value="validation_pending">Bestätigung offen</option>
              <option v-if="user.id > 0" value="password_reset">Passwort zurücksetzen</option>
            </select>
          </div>
        </div>

        <!--
        <div class="row">
          <div class="col-md-5">
            <fg-input type="text"
                      label="Company"
                      :disabled="true"
                      placeholder="Paper dashboard"
                      v-model="user.company">
            </fg-input>
          </div>
          <div class="col-md-3">

            <fg-input type="text"
                      label="Username"
                      placeholder="Username"
                      v-model="user.username">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="email"
                      label="Username"
                      placeholder="Email"
                      v-model="user.email">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="user.firstName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="user.lastName">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Address"
                      placeholder="Home Address"
                      v-model="user.address">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
                      label="City"
                      placeholder="City"
                      v-model="user.city">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
                      label="Country"
                      placeholder="Country"
                      v-model="user.country">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="number"
                      label="Postal Code"
                      placeholder="ZIP Code"
                      v-model="user.postalCode">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>About Me</label>
              <textarea rows="5" class="form-control border-input"
                        placeholder="Here can be your description"
                        v-model="user.aboutMe">

              </textarea>
            </div>
          </div>
        </div>
        -->
        <div class="col-md-12" style="margin-top: 30px; padding-bottom: 20px;">
          <div class="text-right">
            <button :disabled="!isValidEmail(user.email)" type="submit" class="btn btn-fill btn-wd" @click.prevent="updateProfile">
              Speichern
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>

      <div v-if="user.id > 0" class="col-md-12" style="padding-bottom: 20px;">
        <div class="text-right">
          <button type="button" class="btn btn-fill btn-wd" @click.prevent="deleteProfile">
            Benutzer löschen
          </button>
        </div>
      </div>

      <div v-if="isValidEmail(user.email) && user.id > 0" class="col-md-12" style="margin-top: 20px; margin-bottom: 30px; border-bottom: lightgray 2px solid">
      </div>

      <div v-if="isValidEmail(user.email) && user.status === 'validation_pending'" class="row" style="margin-top: 30px;">
        <div class="col-md-9">
          Registrierungs Email an {{ user.email }} senden
        </div>
        <div class="col-md-3">
          <div class="text-right">
            <button type="button" class="btn btn-info btn-fill btn-wd" @click.prevent="resendValidationEmail">
              Senden
            </button>
          </div>
        </div>
      </div>
      <div v-if="user.id > 0 && isValidEmail(user.email)" class="row" style="margin-top: 30px; margin-bottom: 30px;">
        <div class="col-md-9">
          Passwort zurücksetzen Email an {{ user.email }} senden
        </div>
        <div class="col-md-3">
          <div class="text-right">
            <button type="button" class="btn btn-info btn-fill btn-wd" @click.prevent="requestPasswordReset">
              Senden
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    props: {
      id: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    computed: {
      title () {
        if (this.id === 0) {
          return 'Hinzufügen'
        }
        return 'Bearbeiten'
      },
      user () {
        if (this.id === 0) {
          return this.new_user
        }
        const user = this.$store.getters.getUserById(this.id)
        if (user.length > 0) {
          return user[0]
        }
        return {}
      }
    },
    data () {
      return {
        user_betgame_points: '',
        new_password: '',
        new_password_repeat: '',
        sendValidationEmailOnSave: false,
        new_user: {
          id: 0,
          nickname: '',
          email: '',
          firstname: '',
          lastname: '',
          source: '',
          address: '',
          zip: '',
          city: '',
          status: 'active',
          allow_email: false
        }
        /*
        user: {
          company: 'Paper Dashboard',
          username: 'michael23',
          email: '',
          lastName: 'Faker',
          address: 'Melbourne, Australia',
          city: 'melbourne',
          postalCode: '',
          aboutMe: `Oh so, your weak rhyme. You doubt I'll bother, reading into it.I'll probably won't, left to my own devicesBut that's the difference in our opinions.`
        }
        */
      }
    },
    created () {
      if (this.$store.state.userBetgamePoints && this.user.id) {
        const ubp = this.$store.state.userBetgamePoints.filter(s => parseInt(s.fk_user) === parseInt(this.user.id))
        if (ubp.length === 1) {
          this.user_betgame_points = '' + ubp[0].points
        }
      }
    },
    methods: {
      requestPasswordReset () {
        this.$store.dispatch('requestPasswordReset', {
          email: this.user.email
        })
          .then(() => {
            alert('Email gesendet')
          })
      },
      resendValidationEmail () {
        this.$store.dispatch('resendValidationEmail', {
          email: this.user.email
        })
          .then(() => {
            alert('Email gesendet')
          })
      },
      deleteProfile () {
        this.$log.debug('deleteProfile ' + this.user.id)
        if (this.user.id > 0) {
          var r = confirm('Benutzer ' + this.user.nickname + ' (' + this.user.email + ') löschen?')
          if (r === true) {
            this.$store.dispatch('deleteUser', { user_id: '' + this.user.id, betgame_id: '' + this.$store.state.betgame })
              .then(response => {
                this.$router.push('/users')
              })
            /*
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                status: 'inactive'
              }
            }).then(() => {
              this.$router.push('/users')
            })
            */
          }
        }
      },
      updateProfile () {
        if (this.user.id === 0) {
          var valid = false
          if (!this.isNullOrUndefined(this.new_password) && this.new_password.length > 0) {
            if (!this.isNullOrUndefined(this.new_password_repeat) && this.new_password_repeat.length > 0) {
              if (this.new_password.toLowerCase() === this.new_password_repeat.toLowerCase()) {
                valid = true
              }
            }
          }
          if (this.isNullOrUndefined(this.user.nickname) || this.user.nickname.length === 0 || this.user.nickname.length > 100) {
            valid = false
          }
          if (!this.isValidEmail(this.user.email)) {
            valid = false
          }
          if (valid) {
            this.$store.dispatch('addUser', {
              nickname: this.user.nickname,
              email: this.user.email.toLowerCase(),
              password: this.new_password,
              status: this.user.status,
              source: this.user.source,
              address: this.user.address,
              zip: this.user.zip,
              city: this.user.city,
              allow_email: true,
              fk_betgame: this.$store.state.betgame,
              role: 'betgame_user',
              acceptedtos: true,
              push_notifications: false,
              email_notifications: false,
              isadult: true,
              lang: 'de',
              acceptedcop: true,
              firstname: this.user.firstname,
              lastname: this.user.lastname
            }).then((id) => {
              this.$router.push('/user/' + id)
            })
          } else {
            alert('Der Benutzer konnte nicht hinzugefügt werden.')
          }
        } else {
          this.$log.debug('updateProfile ' + this.new_password + ' --- ' + this.new_password_repeat)
          var updatePasswd = false
          if (!this.isNullOrUndefined(this.new_password) && this.new_password.length > 0) {
            if (!this.isNullOrUndefined(this.new_password_repeat) && this.new_password_repeat.length > 0) {
              if (this.new_password.toLowerCase() === this.new_password_repeat.toLowerCase()) {
                updatePasswd = true
              }
            }
          }
          if (updatePasswd) {
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                nickname: this.user.nickname, firstname: this.user.firstname, lastname: this.user.lastname, email: this.user.email, status: this.user.status, source: this.user.source, address: this.user.address, zip: this.user.zip, city: this.user.city, allow_email: this.user.allow_email, password: this.new_password
              }
            }).then(() => {
              alert('Benutzer-Daten wurden aktualisiert')
            })
          } else {
            this.$store.dispatch('updateUser', {
              id: this.user.id,
              content: {
                nickname: this.user.nickname, firstname: this.user.firstname, lastname: this.user.lastname, email: this.user.email, status: this.user.status, source: this.user.source, address: this.user.address, zip: this.user.zip, city: this.user.city, allow_email: this.user.allow_email
              }
            }).then(() => {
              alert('Benutzer-Daten wurden aktualisiert')
            })
          }
          if (this.user_betgame_points && parseInt(this.user_betgame_points) !== 0) {
            const data = {
              'fk_user': parseInt(this.user.id),
              'points': parseInt(this.user_betgame_points),
              'fk_betgame': parseInt(this.$store.state.betgame)
            }
            this.$store.dispatch('updateUserBetgamePoints', data).then(response => {
              if (response.status >= 200 && response.status <= 204) {
              } else {
              }
            }, error => {
              alert(error)
            })
          } else if (!this.user_betgame_points || this.user_betgame_points.trim().length === 0 || (this.user_betgame_points && parseInt(this.user_betgame_points) === 0)) {
            const data = {
              'fk_user': parseInt(this.user.id),
              'points': 0,
              'fk_betgame': parseInt(this.$store.state.betgame)
            }
            this.$store.dispatch('deleteUserBetgamePoints', data).then(response => {
              if (response.status >= 200 && response.status <= 204) {
              } else {
              }
            }, error => {
              alert(error)
            })
          }
        }
        // alert('Your data: ' + JSON.stringify(this.user))
      },
      isNullOrUndefined (data) {
        return data === null || data === undefined
      },
      isValidEmail (email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/BGEditProfileForm.vue